var hero = document.getElementById('hero');
var topbar = document.getElementById('topbar');
var topbarHeight = topbar?topbar.scrollHeight:false;
var menuBar = document.getElementById('menu-bar');
var menuBarHeight = menuBar?menuBar.scrollHeight:false;
var menuButton = document.getElementById('menu-button');
var mobileMenu = document.querySelector('.mobile-nav');
var languageSwitcher = document.getElementById('language-switcher');
var footerInfoSections=document.querySelectorAll('.footer-info-section .footer-info-title a');

window.onload = function() {
  // Site-wide
  AOS.init({
    disable: Math.max(document.documentElement.clientWidth, window.innerWidth || 0) <= 767
  });

  // Homepage Only
  var lgbtBtn = document.querySelector('.hero-button');
  if(lgbtBtn) {
    setTimeout(function(){
      lgbtBtn.className = lgbtBtn.className.replace(' hidden', '');
    }, 1000);
  }
};

/*******************/
/*  Window Scroll  */
/*******************/
window.onscroll = function() {
  if (getScrollTop() === 0) {
      if (menuBar.className.indexOf('sticky') > -1) {
          menuBar.className = menuBar.className.replace(' sticky', '');
          hero.style.marginTop = '0';
      }
  } else {
      if (menuBar.className.indexOf('sticky') === -1) {
          menuBar.className += ' sticky';
          hero.style.marginTop = '-' + topbar.offsetHeight + 'px'; // Adjust margin to the height of the menu bar
      }
  }
};
/******************/
/*     Topbar     */
/******************/
var topbarAnnouncement = (function() {
  var announcementEl = document.getElementById('announcements'),
      announcements = announcementEl.querySelectorAll('div'),
      len = announcements.length,
      current = 0;

  var init = function() {
    if(announcements.length > 1) {
      var timer = setInterval(function() {
        removeClass('#announcements div.active', 'active');
        announcements[current].className += 'active';
        current = (current >= len-1) ? 0 : current + 1;
      }, 3000);
    }
  }

  return {
    init: init
  };
})();

topbarAnnouncement.init();

/******************/
/*      Menu      */
/******************/
menuButton.addEventListener('click', function(e) {
	e.preventDefault();
	if(document.body.className.indexOf(' menu-open') <= -1) {
		document.body.className += ' menu-open';
	} else {
		document.body.className = document.body.className.replace(' menu-open', '');
	}
});

var menuLinks = document.querySelectorAll('li.has-submenu > a');
for (var i = 0; i < menuLinks.length; i++) {
  menuLinks[i].addEventListener('click', function(e) {
    e.preventDefault();
    var parent = this.parentNode,
      openSibling = parent.parentNode.querySelector('.active');
    if(openSibling && openSibling != parent)
      closeMenu(openSibling);
    parent.classList.toggle('active');
  });
}
function closeMenu(el) {
  if(el) {
    var submenu = el.querySelector('ul');
    el.classList.remove('active');
    closeMenu(submenu.querySelector('.active'));
  }
}

document.addEventListener('click', function(e) {
	var navs = document.querySelectorAll('.nav');
	var mobileNavs = document.querySelectorAll('.mobile-nav');
  var languageMenu = document.getElementById('languages');
  var languageButton = document.getElementById('language-switcher');
	for (var i = 0; i < navs.length; i++) {
		if(window.getComputedStyle(navs[i])['display'] === "block") {
			var isClickInside = navs[i].contains(e.target);
			if (!isClickInside)
				removeClass('nav li.active', 'active');
		}
	}
	for (var i = 0; i < mobileNavs.length; i++) {
		if(window.getComputedStyle(mobileNavs[i])['display'] === "block") {
			var isClickInside = mobileNavs[i].contains(e.target);
			if (!isClickInside)
  			removeClass('nav li.active', 'active');
		}
	}
  if(window.getComputedStyle(languageMenu)['max-height'] !== "0px") {
    var isClickInside = languageMenu.contains(e.target);
    if (!isClickInside) {
      languageMenu.className = languageMenu.className.replace(' shown', '');
      languageButton.className = languageButton.className.replace(' shown', '');
    }
  }
});


/*********************/
/* Language Switcher */
/*********************/
languageSwitcher.addEventListener('click', function(e) {
	e.preventDefault();
	var languageMenu = document.getElementById('languages');
	if(languageMenu.className.indexOf(' shown') <= -1) {
		languageMenu.className += ' shown';
    this.className += ' shown';
	} else {
		languageMenu.className = languageMenu.className.replace(' shown', '');
    this.className = this.className.replace(' shown', '');
	}
});

window.addEventListener("hashchange", function(e) {
	if(window.location.hash.indexOf('googtrans(en|') > -1)
		location.reload();
});


/********************/
/* Footer accordion */
/********************/
for (var i = 0; i < footerInfoSections.length; i++) {
	footerInfoSections[i].addEventListener('click', function(e) {
		e.preventDefault();
		var section = this.parentNode.parentNode.parentNode;
		if(section.className.indexOf(' active') <= -1) {
			removeClass('.footer-info-section.active', 'active');
			section.className += ' active';
		} else {
			section.className = section.className.replace(' active', '');
		}
	});
}

/********************/
/*    Trust Logos   */
/********************/
var trustSlider = (function() {
  var trustLogos = document.querySelectorAll('.trust-logos-wrapper .trust-logos');
  var left = 0;

  var init = function() {
    window.addEventListener('scroll',function(e) {
      for (var i = 0; i < trustLogos.length; i++) {
        if(trustLogos[i]) {
          var rect = trustLogos[i].getBoundingClientRect();
          var elemTop = rect.top;
          var innerHeightAdjusted = window.innerHeight - (menuBarHeight + topbarHeight);
          if(isScrolledIntoView(trustLogos[i]), 'top') {
            var left = ((elemTop / innerHeightAdjusted) * 100);
            if (left >= 0 && left <= 100) {
              trustLogos[i].style.left = '-' + (100 - left) + '%';
            }
          } else {
            trustLogos[i].style.left = 0;
          }
        }
      }
    });
  }

  /**
   * Detect when an element is scrolled into view
   * @param  {object}  el           Element to test
   * @param  {string} [part='']     Whether to test the top and/or bottom of the element (default both)
   * @return {Boolean}              Whether the element is scrolled into view
   */
  var isScrolledIntoView = function(el, part = '') {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = false;
    if (part === 'top') {
      isVisible = (elemTop >= window.innerHeight);
    } else if (part === 'bottom') {
      isVisible = (elemBottom <= 0);
    } else {
      isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    }
    return isVisible;
  }

  return {
    init: init
  };
})();

trustSlider.init();

/********************/
/*    Functions     */
/********************/

/**
 * Cross-browser function to get the body element scrollTop value
 * @return {int} the scrollTop value
 */
function getScrollTop(){
  if(typeof pageYOffset!= 'undefined'){
    //most browsers except IE before #9
    return pageYOffset;
  } else {
	  var B = body();
	  return B.scrollTop;
  }
}

/**
 * Cross-browser function to get the document body
 * @return {obejct} The body element
 */
function body() {
	var B = document.body; //IE 'quirks'
	var D = document.documentElement; //IE with doctype
	D = (D.clientHeight)? D: B;
	return D;
}


/**
 * Remove the provided class from the element specified
 * @param  {string} selector     Selector for elements from which to remove class
 * @param  {string} removedClass The class to remove
 * @return {null}
 */
function removeClass(selector, removedClass) {
	var elements = document.querySelectorAll(selector);
	for (var i = 0; i < elements.length; i++) {
    var el = elements[i];
    if (el.className.indexOf(' ' + removedClass) > -1) {
      el.className = el.className.replace(' ' + removedClass, '');
    } else if (el.className.indexOf(removedClass) > -1) {
      el.className = el.className.replace(removedClass, '');
    }
	}
}

/*=============================
=        Scroll To Link       =
=============================*/

var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link')),
  navHeight = document.getElementById("menu-bar").offsetHeight;

scrollLinks.forEach(function(scrollLink) {
  scrollLink.addEventListener('click', function(e) {
    e.preventDefault();

    scrollToElement(document.querySelector(this.getAttribute('href')), -navHeight, 800);
  });
});

function scrollToElement(scrollTo, offset, duration) {
  Velocity(scrollTo, 'scroll', {duration: duration, offset: offset});
}

var sectionId = window.location.hash,
  section = sectionId ? document.querySelector(sectionId) : false;

function addOverflow() {
  var contentWrapper = document.querySelector('.content-wrapper');
  if(contentWrapper)
      contentWrapper.style.overflow = 'hidden';
}

if(!section)
  addOverflow();

if(section) {
  setTimeout(function() {
    addOverflow();
    scrollToElement(section, -navHeight, 800);
  }, 300);
}

/*=================================
=         Lazy Load Images        =
=================================*/
document.addEventListener('DOMContentLoaded', function () {
  var heroImages = [].slice.call(document.querySelectorAll('html:not(.print) #hero img.bg:not(.mobile)')),
      lazyImages = [].slice.call(document.querySelectorAll('html:not(.print) main img:not(.mobile):not(.not-lazy), footer ul.trust-logos img:not(.not-lazy)')),
      active = false,
      heroLazyLoad = function heroLazyLoad() {
    heroImages.forEach(function (img) {
      bgLazyLoad(img);
    });
  };

  // Hero Images
  setTimeout(heroLazyLoad, 1);

  // Regular Images
  var lazyLoad = function lazyLoad() {
    if (active === false) {
      active = true;

      setTimeout(function () {
        lazyImages.forEach(function (img) {
          if (img.getBoundingClientRect().top <= window.innerHeight + 300 && img.getBoundingClientRect().bottom >= 0 && getComputedStyle(img).display !== 'none') {
            if (img.classList.contains('bg')) bgLazyLoad(img);else imgLazyload(img);

            // img.srcset = src;

            // img.classList.remove('lazy');

            lazyImages = lazyImages.filter(function (image) {
              return image !== img;
            });

            if (lazyImages.length === 0) {
              document.removeEventListener('scroll', lazyLoad);
              window.removeEventListener('resize', lazyLoad);
              window.removeEventListener('orientationchange', lazyLoad);
            }
          }
        });

        active = false;
      }, 200);
    }
  };

  document.addEventListener('scroll', lazyLoad);
  window.addEventListener('resize', heroLazyLoad);
  window.addEventListener('resize', lazyLoad);
  window.addEventListener('orientationchange', heroLazyLoad);
  window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyload(img) {
  img.src = img.dataset.src;
  img.classList.add('loaded');
}

function bgLazyLoad(img) {
  var bgArea = img.parentNode,
      mobileBg = img.nextSibling;

  img = checkWidth(768) && mobileBg ? mobileBg : img;

  bgArea.style.backgroundImage = 'url(' + img.getAttribute('data-src') + ')';

  setTimeout(function () {
    bgArea.classList.add('loaded');
    img.style.display = 'none';
  }, 300);
}
